function r(n) {
  return n[0];
}
function t(n) {
  return n[1];
}
export {
  r as x,
  t as y
};
